import { useMemo } from 'react';
import styles from './index.module.scss'
import { Slider, Button } from 'antd';
import { forwardRef } from 'react'
import { useContext } from 'react'
import { AIEditContext } from '../../AIEditContext';
import Iconfont from '@utils/Iconfont';
import Utils from '@utils/utils';
import { AppContext } from '@utils/AppContext';
import { MODESTATE, OPERATETYPE } from '@view/page_v3/AiEdit/CONST'
import { PlusCircleOutlined, MinusCircleOutlined, PlusCircleFilled, MinusCircleFilled } from '@ant-design/icons';

const handRepairBar = forwardRef((props, ref) => {
    const { eraserSize, isDraw, operateType, setOperateType, modeState, paintSize, AIEditLoading } = useContext(AIEditContext)
    const btnPicList = [
        ['icon-smearOutlined', '涂抹', OPERATETYPE.DRAW],
        ['icon-boxselectOutlined', '框选', OPERATETYPE.RECT],
        ['icon-freechoiceOutlined', '自由圈选', OPERATETYPE.CIRCLE],
    ];

    const handleEraser = () => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => handleEraser())
        if (!status) return

        props.createClick('0')
    }

    const sliderDisabled = useMemo(() => {
        return operateType != OPERATETYPE.DRAW
    }, [operateType])

    return (
        <div className={styles.HandRepairBar}>
            <div className={`${styles.HandRepairBarConetent} ${!props.url && styles.disabled}`}>
                <div className={styles.magicEraseBar_btn}>
                    {
                        btnPicList.map((item) => {
                            return <div
                                key={item[0]}
                                onClick={() => setOperateType(item[2])}
                                className={`${styles.magicEraseBar_btn_}  ${operateType == item[2] ? styles.magicEraseBar_btn_selected : null}`}>
                                <Iconfont className={styles.Icon} type={item[0]} />
                                <p>{item[1]}</p>
                            </div>
                        })
                    }
                </div>
                <div className={styles.operationBox}>
                    <div className={styles.operationBoxTitle}>
                        <span className={styles.operateBtn}>
                            <span
                            style={{backgroundColor: modeState == MODESTATE.PAINT ? '#fff': '#F8F9FF'}}
                            onClick={() => props.repairSizeChange(paintSize, MODESTATE.PAINT)}>
                                    {modeState == MODESTATE.PAINT ? <PlusCircleFilled style={{color: '#006EFF'}} /> : <PlusCircleOutlined /> }
                                    <span style={{color: modeState == MODESTATE.PAINT ? '#006EFF': '#000812'}}>增加选区</span>
                            </span>
                            <span
                            style={{backgroundColor: modeState == MODESTATE.ERASER ? '#fff': '#F8F9FF'}}
                            onClick={() => props.repairSizeChange(eraserSize, MODESTATE.ERASER)}>
                                    {modeState == MODESTATE.ERASER ? <MinusCircleFilled style={{color: '#FF3B30'}} /> : <MinusCircleOutlined />}
                                    <span style={{color: modeState == MODESTATE.ERASER ? '#006EFF': '#000812'}}>减少选区</span>
                            </span>
                        </span>
                        <span className={styles.operateValue}>{modeState == MODESTATE.PAINT ? paintSize : eraserSize}</span>
                    </div>
                    {
                        modeState == MODESTATE.PAINT ? <Slider
                            value={paintSize}
                            min={1}
                            defaultValue={paintSize}
                            tooltip={{ formatter: null }}
                            onChange={(vale) => props.repairSizeChange(vale, MODESTATE.PAINT)}
                            onChangeComplete={(vale) => props.repairSizeChange(paintSize, MODESTATE.PAINT)}
                            disabled={sliderDisabled} /> : <Slider
                            value={eraserSize}
                            min={1}
                            defaultValue={eraserSize}
                            tooltip={{ formatter: null }}
                            onChange={(vale) => props.repairSizeChange(vale, MODESTATE.ERASER)}
                            onChangeComplete={(vale) => props.repairSizeChange(eraserSize, MODESTATE.ERASER)}
                            disabled={sliderDisabled} />
                    }
                </div>

                <Button
                    disabled={isDraw.length == 0}
                    className={`${styles.createBtn} ${isDraw.length > 0 ? null : styles.createBtnForbid}`}
                    type="primary"
                    loading={AIEditLoading}
                    onClick={handleEraser}
                >
                    应用改动
                </Button>
            </div>
        </div>
    )
})

export default handRepairBar;
